import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST /files/getprofileimageuploadurl</h1>
        </div>
        <p>
          This method creates and returns a file upload url for a user's profile
          image. Creates and returns a URL and fileKey for uploading a profile
          image. Files are stored on Google's Cloud Storage Platform. For more
          information, see the{" "}
          <Link to="/guides/filesystem">File System Guide</Link>.
        </p>
        <p />
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>files</td>
                <td>
                  An array of fileData objects. Each fileData object represents
                  a different file
                </td>
                <td>Array of Objects</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>Content-Type</td>
                <td>MIME type of file to upload</td>
                <td>String</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>Content-Length</td>
                <td>The size of the file being uploaded, in bytes</td>
                <td>Number</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>dimension</td>
                <td>The display dimension of the image.</td>
                <td>String "original" or number</td>
                <td>No</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/files/getprofileimageuploadurl
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"files":[{"\n"}
          {"    "}
          {"{"}
          "Content-Type":"image/png","dimension":"original","responseDisposition":"1234567890"
          {"}"},{"\n"}
          {"    "}
          {"{"}"Content-Type":"image/png","dimension":160{"}"}
          {"\n"}
          {"  "}]{"\n"}
          {"}"}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data": [{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"fileKey":
          "pictures/pfpic_user_287f310f-aba5-4879-a18e-247c07c4894a",{"\n"}
          {"      "}"url":
          "https://storage.googleapis.com/onesnatesting/pictures%2Fpfpic_user_287f310f-aba5-4879-a18e-247c07c4894a?GoogleAccessId=logan-testing@onesnatesting.iam.gserviceaccount.com&amp;Expires=1493149882&amp;Signature=fJd96uP6Wk9wCug4LUIvjEuJrrD3hZCYnSCeqsdLvm0NHQDBlX8t%2BYL%2FoQhDvaUyAi8Fw5je8iUFQ%2Bu8xqoavpwbofk6WuPn78VPPmduDu6oY6ZNQTVKHkIbShTV0bjiQXH2bKyPDgeXeRyQueO6X%2BOaIMBEP5fL7cwR5rfyoPjFFmD%2Bzy4KOvP2rAMC2K%2FCJaDMN3x6nhZ1gaqeQN4P5e4fL0kNkqCHYSshse47QPCUM%2FHD2uFxKfyezSTv95tcNndHarhUwdkcX6RG8al6qz2UaKbGzhUj1PPKkmkr%2BvwC3MGJ17sewDlYnyEhZPSmMW0yWyGesVg5XYE6zkDmjQ%3D%3D&amp;response-content-disposition=1234567890"
          {"\n"}
          {"    "}
          {"}"},{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"fileKey":
          "pictures/pfpic_user_4ca9eec2-31b8-41d0-a8f2-25021fb0b562/160_160",
          {"\n"}
          {"      "}"url":
          "https://storage.googleapis.com/onesnatesting/pictures%2Fpfpic_user_4ca9eec2-31b8-41d0-a8f2-25021fb0b562%2F160_160?GoogleAccessId=logan-testing@onesnatesting.iam.gserviceaccount.com&amp;Expires=1493149882&amp;Signature=pGelG6OzAZgQ6ykNFWsOHMr%2BJBVXz1BCCR3NwgVIuezeR2dSHPrheskWvz0AiQie0nbRO%2FpKt9pr0HvYZGtEDDREGZTXpyw%2FkOzY3CVYj8gvDtiuSt%2BErTkNpsruNJvqzu7zo%2BqbGljs8Y0k6ppG15UKt7JC3mAAnhBjmw%2BsvmWdEHaJMqK1GbZzYIYwbOpRytftWMwidegW%2FSOxoaFXrADEeOD2yhqRHj2FnNicZRRPnVElI72O53GXqYDEpNrX3zMbaTEPPoVFcRCqy4v322TW%2BCng8ftdvMantUL4dxG2qUUrwApC1ldEye1hi%2BI5xUwWBevIuEMamkyhqcGXvA%3D%3D"
          {"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"  "}]{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
